import { Link } from 'react-router';
import GenerateFlag from "@/components/generate-flag";
import FormatDate from "@/components/formatting/format-date";
import IRetreatOverview from "@/models/retreats/iretreat-overview";

import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

interface IProps {
    retreat: IRetreatOverview;
}

const ViewCardRetreat: React.FC<IProps> = ( { retreat } ) => {
    const cloudinary = new Cloudinary({ cloud: { cloudName: 'dkc2mtgso' } });

    function getBackgroundColour(occupancy: number, maxOccupancy: number, instructorId: number, statusId: number) {
        if (!instructorId || statusId == 2) { // 2 = Cancelled
            return "bg-br-red";
        }
        else if (occupancy > 0 && occupancy === maxOccupancy) {
            return "bg-br-green";
        }
        else if (occupancy > 6) {
            return "bg-br-green";
        }
        else {
            return "bg-br-blue-300";
        }
    }

    return (
        <Link to={`/view/${retreat.id}`}>
            <div className="w-full md:w-96 mx-2 md:mx-1" key={retreat.id}>
                <div
                    key={retreat.id}
                    className={
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-expect-error
                        `w-full md:w-96 mb-6 border-2 transition transition-tim rounded-l-md rounded-r-sm flex hover:brightness-110 ${retreat.occupancy > 0 && retreat.occupancy === retreat.maxOccupancy ?  "border-amber-400" : ""} ${getBackgroundColour(retreat.occupancy, retreat.maxOccupancy, retreat.instructorId, retreat.statusId)}`
                    }
                >

                    <div className="relative">
                        {!retreat.instructorImage ? (
                            <div className=" aspect-square">
                                <i className="fas fa-user-astronaut fa-5x text-center h-24 w-24 pt-2 pl-3"></i>
                            </div>
                        ) : (
                            <AdvancedImage className="w-24 h-24 aspect-square object-cover rounded-l-md" cldImg={cloudinary
                                .image(retreat.instructorImage)
                                .format('auto') // Optimize delivery by resizing and applying auto-format and auto-quality
                                .quality('auto:best')
                                .resize(auto().gravity(autoGravity()).width(192).height(192))} // Transform the image: auto-crop to square aspect_ratio}
                            />
                        )}
                        <div className="absolute top-0 left-1">
                            <GenerateFlag country={retreat.country} />
                        </div>
                    </div>

                    <div>
                        <h1 className="px-3 py-1">
                            <span className="font-bold">
                                <FormatDate date={retreat.startDate} /> - <FormatDate date={retreat.endDate} />
                            </span>
                        </h1>

                        <div className="float-right pt-10">
                            {retreat.isMissingPayments && (
                                <i className="fas fa-usd-circle" style={{color: "#fefb00"}} title="Missing payments"></i>
                            )}
                        </div>
                        
                        <div className="text-sm px-3">
                            <div>
                                <i className="text-center w-4 mr-1 fas fa-user"></i> {retreat.instructor}
                            </div>
                            <div>
                                <i className="text-center w-4 mr-1 fas fa-house"></i> {retreat.venue}
                            </div>
                            <div>
                                <i className="text-center w-4 mr-1 fas fa-fire-alt"></i> {retreat.occupancy}/{retreat.maxOccupancy}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default ViewCardRetreat;